module.exports = __webpack_public_path__ + "img/icon-scan-smartphone-green@3x.3c0080e9.png";